import React, { useEffect, useState } from 'react';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { Field } from '@vtblife/uikit/dist/legacy';
import { useUserRegion } from '@vtblife/block-kit-utils';
import { RegionSuggest } from './region-suggest';
import { DefaultRegions } from './default-regions';
const SelectRegion = ({ value, onChange }) => {
    const [isChangedByUser, setIsChangedByUser] = useState(!!value);
    const userRegion = useUserRegion();
    useEffect(() => {
        if (!isChangedByUser && userRegion && userRegion.userRegionName && userRegion.userRegionId) {
            onChange({ label: userRegion.userRegionName, value: userRegion.userRegionId });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRegion]);
    const handleChange = (value) => {
        setIsChangedByUser(true);
        onChange(value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RegionSuggest, { value: value, onChange: handleChange }),
        React.createElement(DefaultRegions, { onRegionSelect: handleChange })));
};
const SelectRegionField = Field(SelectRegion, false, false);
export const FormikSelectRegionField = createFormikComponent(SelectRegionField, mapFieldToInputProps);
//# sourceMappingURL=formik-select-region-field.js.map